import type React from 'react'
import { createContext, useContext } from 'react'
import type { RadioButtonSize } from './RadioButton.styles'

export interface RadioButtonContextValues {
  name?: string
  value?: string | number
  disabledAll: boolean
  inGroup: boolean
  updateState: ((value: string | number | undefined) => void) | null
  size: RadioButtonSize
}

export const RadioButtonContext = createContext<RadioButtonContextValues>({
  value: '',
  disabledAll: false,
  inGroup: false,
  updateState: null,
  size: 'xl'
})
export const RadioButtonContextProvider =
  RadioButtonContext.Provider as React.Provider<RadioButtonContextValues>
export const useRadioButtonContext = () => useContext(RadioButtonContext)
